import { render } from "./UsoPracticas.vue?vue&type=template&id=58cb4766&scoped=true"
import script from "./UsoPracticas.vue?vue&type=script&lang=js"
export * from "./UsoPracticas.vue?vue&type=script&lang=js"

import "./UsoPracticas.vue?vue&type=style&index=0&id=58cb4766&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cb4766"]])

export default __exports__